import {intlLocale} from '../../languages';
import React from 'react';
import {Link} from 'react-router';
import {useTranslation} from 'react-i18next';
import BrandMark from '../BrandMark';

export function ArticleDate({value}) {
    const {i18n} = useTranslation();
    return (
        <time dateTime={value}>
            {new Intl.DateTimeFormat(intlLocale(i18n.language), {dateStyle: 'medium', timeZone: 'UTC'}).format(new Date(value))}
        </time>
    );
}

export function ArticleMeta({article}) {
    const {t} = useTranslation();
    return (
        <div className="blog-meta">
            <ArticleDate value={article.publishedAt} />
            <span aria-hidden="true">·</span>
            <span>{t('blog.readingTime', {minutes: article.readingMinutes})}</span>
        </div>
    );
}

export default function BlogCard({article, heading: Heading = 'h2'}) {
    const {t} = useTranslation();
    return (
        <article className="blog-card step-card">
            <Link to={article.path} className="blog-card-link">
                <div className="blog-card-media">
                    {article.cover ? (
                        <img src={article.cover.url} alt={article.cover.alt} loading="lazy" decoding="async" />
                    ) : (
                        <span className="blog-card-art" aria-hidden="true">
                            <BrandMark />
                        </span>
                    )}
                </div>
                <div className="blog-card-copy">
                    <ArticleMeta article={article} />
                    <Heading title={article.title}>{article.title}</Heading>
                    <p>{article.description}</p>
                    <span className="blog-read-link">
                        {t('blog.readArticle')}
                        <span aria-hidden="true">↗</span>
                    </span>
                </div>
            </Link>
        </article>
    );
}
